import { createSlice } from '@reduxjs/toolkit';

export interface IListState {
  list: Array<any>;
}

const initialState: IListState = {
  list: [],
};
export const menuListSlice = createSlice({
  name: 'menuList',
  initialState,
  reducers: {
    setMenuList: (state, action) => {
      state.list = action.payload
    },
  }
});

export const { setMenuList } = menuListSlice.actions;
export default menuListSlice.reducer;
